import React, { FC } from 'react'
import { Patient as FHIRPatient } from '@teschglobal/tg-fhir-react-components/dist/types'
import FhirLoader from '../../../FhirLoader'
import { Patient } from '@teschglobal/tg-fhir-react-components'
import useFhirConfig from '../../../../hooks/admin/useFhirConfig'

type MemberProfileProps = {
  patientData: FHIRPatient | undefined;
  loading: boolean;
}

const MemberProfile: FC<MemberProfileProps> = ({ patientData, loading }) => {
  const { patientAccessFhirConfig, handleSelectOrganization } = useFhirConfig()

  if (loading) {
    return <FhirLoader message='Loading Member Profile...' />
  }

  return (
    <div>
      <section>
        <Patient
          data={patientData}
          fhirApiConfig={patientAccessFhirConfig}
          onSelectOrganization={handleSelectOrganization}
        />
      </section>
    </div>
  )
}

export default MemberProfile